import { gql } from "@apollo/client";

export const GET_LIST_TICKETS = gql`
query Filterlisttickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $array_tpid: jsonb, $ticketStatus: String) {
  filterlisttickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},tp_status:{_in:["List","DelistInProgress"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_is_support_vanderbilt_nil_fund
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},tp_status:{_in:["List","DelistInProgress"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_NEW_TICKETS = gql`
query filterticketswithvlids($enddate: date, $leagueId: jsonb, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $array_tpid: jsonb, $ticketStatus: jsonb, $paymentStatus: jsonb, $payoutType: String = null) {
  filterticketswithvlids : filterlistticketswithvlids(args: {array_tpid: $array_tpid, enddate: $enddate, leagueid: $leagueId, payment_status_param:$paymentStatus, payout_type: $payoutType, startdate: $startdate, ticket_status:$ticketStatus, ticketid:$ticketId, tpid: $ticketPlacementId}, limit: $pageSize, offset: $pageOffset, order_by: {latest_update: desc}) {
    event_date
    event_date_time
    event_id
    event_name
    event_status
    grouped_ticket_data
    latest_update
    league_id
    league_name
    payment_status
    payout_status
    row
    seat_range
    section
    total_count
    tp_list_price
    tp_logitix_amount
    tp_mobile_display_status
    tp_sold_amount
    tp_status
    tp_vl_listing_id
    user_id
    user_email
    user_name
    ticket_id
  }
}
`

export const GET_NEW_TICKETS_GROUPED = gql` 
query getTicketsGrouped($enddate: date, $leagueId: jsonb, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $array_tpid: jsonb, $ticketStatus: jsonb, $paymentStatus: jsonb, $payoutType: String = null)  {
  getTicketsGrouped(getTicketsGroupedInput: {array_tpid: $array_tpid, enddate: $enddate, leagueId: $leagueId, pageOffset: $pageOffset, pageSize: $pageSize, paymentStatus: $paymentStatus, payoutType: $payoutType, startdate: $startdate, ticketId: $ticketId, ticketPlacementId: $ticketPlacementId, ticketStatus: $ticketStatus}) {
      filterlistticketswithvlids{
        event_date
        event_date_time
        event_id
        event_name
        event_status
        grouped_ticket_data
        latest_update
        league_id
        league_name
        payment_status
        payout_status
        seat_range
        row
        ticket_id
        section
        total_count
        tp_list_price
        tp_mobile_display_status
        tp_logitix_amount
        tp_sold_amount
        tp_status
        tp_vl_listing_id
        user_email
        user_id
        user_name
      }
    }
  }
`;

export const PUBLISH_TICKETS = gql`
mutation publishTickets($publishTicketsInput: PublishTicketsInput!) {
  publishTickets(publishTicketInput: $publishTicketsInput) {
    message
  }
}
`;

export const GET_MANAGE_TICKETS = gql`
query Filtermanagetickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketStatus: String, $ticketId: uuid, $tpId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $day: Int, $search_event: String = "%", $array_tpid: jsonb) {
  filtermanagetickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_status
    tp_list_price
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    tp_validity_status
    tp_status
    tp_is_published
    e_id
    t_id
    tp_id
    e_status
    user {
      u_role
    }
    full_name
    u_email_id
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid,payment_status:null,ticket_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_in:["List","DelistInProgress"]}}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid,payment_status:null,ticket_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const VALIDATE_UPDATE = gql`
  mutation UpdateTicketStatus ($isValid: Boolean, $ticketPlacementId: [uuid!]!, $isUndoRequest: Boolean) {
    updateTicketStatus(ticketPlacementId: $ticketPlacementId, isValid: $isValid, isUndoRequest: $isUndoRequest) {
      message
    }
  }
`;

export const NEW_DELIST_TICKETS = gql`
mutation delistTickets ($ticketPlacementIds: [uuid!]!, $requestedEmailId: String!) {
  delistTickets(delistTicketsInput: {ticketPlacementIds:$ticketPlacementIds,requestedEmailId:$requestedEmailId}) {
    message
  }
}`


export const DELIST_TICKETS = gql`
  mutation delistTickets($ticketPlacementIds: [uuid!]!) {
  delistTickets(delistTicketsInput: { ticketPlacementIds: $ticketPlacementIds }) {
    message
  }
}`

export const EDIT_TICKET_PRICE_BY_SUPER_USER = gql`
mutation EditTicketPriceBySuperUser(
  $tp_ids: [uuid!]!,
  $tp_list_price: Float!
) {
  editTicketPriceBySuperUser(
    editTicketPriceInput: {
      ticketPlacementIds: $tp_ids,
      tp_list_price: $tp_list_price
    }
  ) {
    message
  }
}
`;

export const GET_LEAGUES_LIST = gql`
query LeaguesDropdownFilter {
  leagues(where: {l_deleted_at: {_is_null: true}}) {
    l_id
    l_name
  }
}
`;


export const GET_SOLD_TICKETS = gql`
query FilterSoldTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $array_tpid: jsonb, $paymentStatus: String, $payoutType: String = null) {
  FilterSoldTickets: filterlisttickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:$paymentStatus,ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_status
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_logitix_amount
    tp_sold_amount
    tp_payment_status
    tp_list_price
    tp_quick_cut_amount
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_payout_status
    tp_is_support_vanderbilt_nil_fund
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:$paymentStatus,ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:null,ticket_status:null,payout_type:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_in:["List","DelistInProgress"]}}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const INVOICE_DETAILS_DOWNLOAD = gql`
query InvoiceDetails ($ticketPlacementId: uuid!) {
  ticket_placement_by_pk(tp_id: $ticketPlacementId) {
    tp_id
    tp_logitix_amount
    tp_sold_amount
    tp_quick_cut_amount
    tp_is_support_vanderbilt_nil_fund
    payment_transaction {
      transactionId: pt_invoice_number
      status: pt_transaction_status
      paymentUpdated: pt_transaction_date
      payementId: pt_id
      stripe_transfers {
        st_invoice
      }
    }
    seatNo: tp_seat_no
    section: tp_section
    row: tp_row
    ticket {
      event {
        eventName: e_name
        eventDate: e_date
        eventAddress: e_address
        eventId: e_id
        eventBrandName: e_brand_name
        eventStatus: e_status
      }
    }
  }
}
`

export const PAYOUT_TICKET = gql`
  mutation InvoiceNumberUpdate($ptInvoiceNumber: String!, $tpId: [uuid!]) {
    update_payment_transaction(
      where: {
        pt_deleted_at: { _is_null: true }
        ticket_placement: {
          tp_status: { _eq: Sold }
          tp_payment_status: { _in: [Failed, Inprogress] }
          tp_id: { _in: $tpId }
        }
      }
      _set: {
        pt_invoice_number: $ptInvoiceNumber
        pt_transaction_date: "now()"
        pt_transaction_status: Success
      }
    ) {
      affected_rows
    }
    update_ticket_placement(
      where: {
        tp_id: { _in: $tpId }
        tp_payment_status: { _in: [Failed, Inprogress] }
        payment_transaction: { pt_transaction_status: { _eq: Success } }
      }
      _set: { tp_payment_status: Success }
    ) {
      affected_rows
    }
  }
`;

export const DELIST_TICKET = gql`
mutation delistTicketByAdmin ($ticketPlacementId: uuid!) {
  delistTicketByAdmin(ticketPlacementId: $ticketPlacementId) {
    message
  }
}
`

export const AUTO_PAYOUT = gql`
mutation TransferAmountToUsersByTicket($ticketPlacementId: String!) {
  transferAmountToUsersByTicket(ticketPlacementId: $ticketPlacementId) {
    message
  }
}
`

export const UPDATE_LIST_PRICE = gql`
mutation updateListPriceByTpId ($tpId: uuid!, $listPrice: float8!) {
  update_ticket_placement_by_pk(pk_columns: {tp_id:$tpId}, _set: {tp_list_price:$listPrice, last_priced_at: "now()"}) {
    tp_id
    tp_list_price
    last_priced_at
    tp_section
  }
}`;

export const GET_MANAGE_TICKETS_BY_LOGITIXUSER = gql`
query FiltermanageticketsByLogitixWithTimeZone ($enddate: date, $leagueId: uuid, $startdate: date, $ticketStatus: String, $ticketId: uuid, $tpId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $day: Int, $search_event: String = "%", $array_tpid: jsonb) {
  filtermanagetickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_status
    tp_validity_status
    tp_status
    tp_is_published
    e_id
    t_id
    tp_id
    e_status
    user {
      u_role
    }
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid,payment_status:null,ticket_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}}],tp_status:{_in:["List","DelistInProgress"]}}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid,payment_status:null,ticket_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_LIST_TICKETS_BY_LOGITIXUSER = gql`
query FilterlistticketsByLogitixWithTimeZone ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $array_tpid: jsonb, $ticketStatus: String) {
  filterlisttickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},tp_status:{_in:["List","DelistInProgress"]},_or:[{e_name:{_ilike:$search_event}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    e_id
    t_id
    tp_id
    tp_list_price
    tp_status
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},tp_status:{_in:["List","DelistInProgress"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_SOLD_TICKETS_BY_LOGITIXUSER = gql`
query FilterSoldTicketsByLogitixWithTimeZone ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $array_tpid: jsonb, $paymentStatus: String) {
  FilterSoldTickets: filterlisttickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:$paymentStatus,ticket_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_status
    e_id
    t_id
    tp_id
    tp_logitix_amount
    tp_sold_amount
    tp_payment_status
    tp_list_price
    e_brand_name
    e_status
    tp_quick_cut_amount
    e_time_zone
    e_date_time_zone
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:$paymentStatus,ticket_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:null,ticket_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}}],tp_status:{_in:["List","DelistInProgress"]}}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const EDIT_TICKET = gql`mutation editTickets ($editTicketsInput: EditTicketsInput) {
  editTickets(editTicketsInput: $editTicketsInput) {
    message
  }
}`;

export const GET_EDIT_TICKET_DETAIL = gql`
query getTicketDetailsBytpid ($tp_id: uuid!) {
  ticket_placement(where: {tp_id:{_eq:$tp_id}}) {
    tp_id
    tp_row
    tp_seat_no
    tp_section
    tp_status
    ticket {
      event {
        e_address
        e_name
        e_cdt_date_with_year
        e_status
        e_date
        e_id
      }
      user {
        u_full_name
        u_email_id
      }
    }
  }
}`;

export const FORCE_UPDATE_TICKET = gql`
mutation editTickets($e_id: uuid!, $tp_id: uuid!, $tp_section: String!, $tp_row: String!, $tp_seat_no: Int!) {
  editTickets(e_id: $e_id, tp_id: $tp_id, tp_section: $tp_section, tp_row: $tp_row, tp_seat_no: $tp_seat_no) {
    message
  }
}
`;

export const GET_DELIST_AND_RETURN_TICKETS = gql`
query Filterreturntickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $array_tpid: jsonb, $ticketStatus: String) {
  filterreturntickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},tp_status:{_in:["List","DelistInProgress"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_DELIST_AND_RETURN_TICKETS_BY_LOGITIXUSER = gql`
query FilterreturnticketsByLogitixWithTimeZone ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $array_tpid: jsonb, $ticketStatus: String) {
  filterreturntickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    e_id
    t_id
    tp_id
    tp_list_price
    tp_status
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},tp_status:{_in:["List","DelistInProgress"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const RETURN_TICKET = gql`
mutation UpdateReturnTickets ($ticketPlacementId: [String!]!) {
  returnTickets(ticketPlacementId: $ticketPlacementId) {
    message
  }
}
`;

export const GET_DELIST_AND_UNSOLD_TICKETS = gql`
query FilterUnsoldTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $array_tpid: jsonb, $ticketStatus: String) {
  filterUnsoldTickets: filterreturntickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_is_support_vanderbilt_nil_fund
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},tp_status:{_in:["List","DelistInProgress"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}`;

export const GET_DELIST_AND_UNSOLD_BY_LOGITIX = gql`
query FilterUnsoldTicketsByLogitixWithTimeZone ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $array_tpid: jsonb, $ticketStatus: String) {
  filterUnsoldTickets: filterreturntickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    e_id
    t_id
    tp_id
    tp_list_price
    tp_status
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},tp_status:{_in:["List","DelistInProgress"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:$ticketStatus,payment_status:null}, where: {tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const UPDATE_TP_PAYOUT_STATUS = gql`
mutation UpdateTpPayoutStatus ($tpId: uuid!) {
  updateTpPayoutStatus(tpId: $tpId) {
    message
  }
}
`;

export const UNDO_DELIST_REQUEST_TO_LIST = gql`
  mutation UndoDelistRequestToList($tpId: uuid!) {
    undoDelistRequestToList(tpId: $tpId) {
      message
    }
  }
`;

export const GET_MANAGE_TICKETS_BY_SUPER_USER = gql`
query Filtermanagetickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketStatus: String, $ticketId: uuid, $tpId: uuid, $pageSize: Int, $pageOffset: Int, $u_id:uuid ,$order_by: [getmanageticket_order_by!], $day: Int, $search_event: String = "%", $array_tpid: jsonb) {
  filtermanagetickets(
    args: {
      enddate:$enddate,
      leagueid:$leagueId,
      startdate:$startdate,
      ticket_status:$ticketStatus,
      day:$day,
      ticketid:$ticketId,
      tpid:$tpId,
      array_tpid:$array_tpid
    },
    where: {
      tp_is_published:{_eq:false},
      tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},
      _or:[
        {e_name:{_ilike:$search_event}},
        {full_name:{_ilike:$search_event}},
        {u_email_id:{_ilike:$search_event}}
      ],
      _and: {u_id: {_eq: $u_id}}
    },
    limit: $pageSize,
    offset: $pageOffset,
    order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_status
    u_id
    u_first_name
    u_last_name
    tp_validity_status
    tp_status
    tp_is_published
    e_id
    t_id
    tp_id
    e_status
    user {
      u_role
    }
    full_name
    u_email_id
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_is_support_vanderbilt_nil_fund
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {_and: {u_id: {_eq: $u_id}},tp_is_published:{_eq:false},tp_status:{_in:["ToBeVerified","Verified","ListingRequestCancelled"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid,payment_status:null,ticket_status:null}, where: {_and: {u_id: {_eq: $u_id}},tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_in:["List","DelistInProgress"]}}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid,payment_status:null,ticket_status:null}, where: {_and: {u_id: {_eq: $u_id}},tp_is_published:{_eq:true},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {_and: {u_id: {_eq: $u_id}},tp_status:{_in:["Delist","Return"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filterreturntickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {_and: {u_id: {_eq: $u_id}},tp_status:{_in:["Unsold"]},_or:[{e_name:{_ilike:$search_event}},{full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}) {
    aggregate {
      count
    }
  }
}
`;
